import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { type AircallNumbersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersStore'
import styles from './styles.module.scss'

type IAssignedNotFoundMessageProps = {
  store: AircallNumbersStore
}

export const AssignedNotFoundMessage = observer(({ store }: IAssignedNotFoundMessageProps) => {
  const { numbersListStore, setActiveTabKey } = store
  const { assignedItems, unassignedItems, items } = numbersListStore

  const hasNoNumbers = items.length === 0
  const hasNoSearchResults =
    items.length > 0 && assignedItems.length === 0 && unassignedItems.length === 0

  const isEmpty = hasNoNumbers || hasNoSearchResults
  const text = hasNoNumbers ? 'No numbers' : 'No results found'

  if (isEmpty) {
    return (
      <Typography
        ariaLabel='no_assigned_numbers'
        color='var(--content-primary-tertiary)'
        variant='body-rg-medium'
      >
        {text}
      </Typography>
    )
  }

  return (
    <div className={styles.container}>
      <Typography
        ariaLabel='no_assigned_numbers'
        variant='body-rg-medium'
        color='var(--content-primary-primary)'
        marginBottom={4}
      >
        No assigned numbers
      </Typography>
      <Typography
        ariaLabel='unassigned_numbers'
        variant='body-md-regular'
        color='var(--content-primary-tertiary)'
        marginBottom={20}
      >
        You have {unassignedItems.length} unassigned numbers
      </Typography>
      <Button
        text='Assign numbers'
        contained='tertiary'
        onClick={() => {
          setActiveTabKey('unassigned')
        }}
      />
    </div>
  )
})
